module.exports = __webpack_public_path__ + "static/media/loginBG.602e872a.png";